import { useState } from 'react';
import './QuizType2.scss';
import Column from './Column/Column';
import QuestionCount from '../QuestionCount/QuestionCount';

import { DragDropContext } from '@hello-pangea/dnd';

import { setNewStateForQuizType2 } from '../quizSlice';

const QuizType2 = (props) => {
  


  
 
  const {dispatch} = props;

// FIND DATA  BY QUESTION ID
const questionId = props.quizRedux.questionIdForDB;

const  findQuestionById = (questionId) => {
  console.log(questionId);
    const data = props.quizRedux.initialDataForQuizType2;
    console.log(data);
    const index = data.findIndex(item => item.id === Number(questionId));
    

  console.log(index);
  return index;
};
const indexOfQuestion = findQuestionById(questionId);
console.log(indexOfQuestion);

//SET DATA BY QUESTION ID
  const initialData = props.quizRedux.initialDataForQuizType2[indexOfQuestion];
console.log(initialData);


//ON CLICK ANSWER DND1
const onAnswerDND1 = () => {
  console.log('Start check result DND1');

  // SET STATUS IF QUEST COMPLETE
  //setStateAnswerStatus(true);


  const arr1 = initialData.columns['column-1'].taskIds;
  const arr2 = initialData.columns['column-1'].taskRightIds;
  const n1 = arr1.toString();
  //console.log(n1);
  const result = arr1.toString() === arr2.toString();

  // SET RESULT INDICATOR
  let resultIndicator;
  if (result) {
   //console.log(result);
    console.log('ARRAY EQUEL!!!');

    //setStateDataStatusResult('100');
    resultIndicator = '100';

  } else {
    console.log('ARRAY not EQUEL!!!');
    //setStateDataStatusResult('0');
    resultIndicator = '0';
  }
 
 
 //const resultIndicator = stateDataStatusResult ? '0' : '100';
 // console.log(resultIndicator);

  props.onAnswerSelected(999, resultIndicator);


}


// ON DRAG END 1 column
const onDragEnd = (result) => {
  const {destination, source, draggableId} = result;
  if (!destination) {
    return;
  }
  if (
    destination.droppableId === source.droppableId &&
    destination.index === source.index
  ) {
    return;
  }
  const column = initialData.columns[source.droppableId];
  const newTasksId = Array.from(column.taskIds);
  newTasksId.splice(source.index, 1);
  newTasksId.splice(destination.index, 0 , draggableId);

  const newColumn = {
    ...column,
    taskIds: newTasksId,
  }

  const  newState = {
    ...initialData,
    columns: {
      ...initialData.columns,
      [newColumn.id]: newColumn
    },
  }
  console.log('new state before dispatch');
  
  dispatch(setNewStateForQuizType2(newState));




}

//NEXT QUESTION
const nextQuestion = () => {
            let style;
          

           if (props.quizRedux.selectedItem != null) {
                style = ''
            } else {
                style = 'disabled'
            }
 
           //SEND NEXT SORT TYPE OF QUESTION
            return (
                <div>
                    <button onClick={props.nextQuestion.bind(this, props.quizRedux.dataQuizQuestions.length !== (props.quizRedux.counterQuestion +1) ? props.quizRedux.dataQuizQuestions[props.quizRedux.counterQuestion+1].sort_quest : null)}  disabled={style}>Следующий</button>
                </div>
            )

    }

// RENDER COLUMN 1 VERSION
const renderDND1 =() => {
  console.log('start render DND');
  return (
    <div>

    <div className="Quiz-header">
  
       <QuestionCount 
           counter={props.quizRedux.questionId} 
           total={props.quizRedux.questionLength}  
      />
                      
    </div>
   
        <DragDropContext onDragEnd={onDragEnd}>
          <p className='text-main'>{initialData.text}</p>
            {
                initialData.columnOrder.map(columnId => {
                  const column = initialData.columns[columnId];
                  console.log(column);
                  const tasks = column.taskIds.map(taskId => initialData.tasks[taskId]);
                // const title = '1.set in order'
                  return <Column key={column.id} column={column} tasks={tasks}
                   styleAnswer={props.styleAnswer}
                   isSelected={props.isSelected}
                   />
                } )
            }
          
          </DragDropContext>
          <button className='main-button' onClick={onAnswerDND1} disabled={props.isSelected} >Ответить</button>
    </div>
)};


    return (
      <div className="Quiz">
     
        {renderDND1()}
        {nextQuestion()}
 
  
      </div>
    );




  }
  
  export default QuizType2;